export default __webpack_public_path__ + "static/media/icon-Table-Delete.d25339cd.svg";